'use client';

import { useRouter } from "hooks/navigation-router-with-loading";
import NotFound from "organisms/NotFound";

export default function Page() {
    const router = useRouter();
    function homeRoute() {
        router.push('/');
    }
    return (
        <NotFound
            heading='404 Error'
            title='Sorry, this page isn’t available.'
            ctaLabel="Go to Home"
            onClick={homeRoute}
            isShowIcon={false}
        />
    )
}
